module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-right-bottom-stone-path-background.cded60e1.png";